import {
  createLightTheme,
  createDarkTheme,
  BrandVariants,
} from '@fluentui/react-components';

// Microsoft Blue brand variants
const microsoftBrand: BrandVariants = {
  10: '#061724',
  20: '#082338',
  30: '#0A2E4A',
  40: '#0C3B5E',
  50: '#0E4775',
  60: '#0F548C',
  70: '#1160A4',
  80: '#0F6CBD',
  90: '#0078D4', // Primary Microsoft Blue
  100: '#1890F1',
  110: '#3AA0F3',
  120: '#6CB1F7',
  130: '#C7E0F4',
  140: '#DEECF9',
  150: '#EFF6FC',
  160: '#F5FAFF',
};

export const lightTheme = createLightTheme(microsoftBrand);
export const darkTheme = createDarkTheme(microsoftBrand);

// Custom theme tokens
export const themeTokens = {
  colors: {
    // Microsoft Brand
    microsoftBlue: '#0078D4',
    microsoftBlueDark: '#106EBE',
    microsoftBlueLight: '#50E6FF',

    // Accent Colors
    successGreen: '#107C10',
    warningOrange: '#FF8C00',
    errorRed: '#D13438',
    infoBlue: '#00BCF2',

    // Neutral Palette
    gray10: '#FAF9F8',
    gray20: '#F3F2F1',
    gray30: '#EDEBE9',
    gray40: '#E1DFDD',
    gray50: '#D2D0CE',
    gray60: '#C8C6C4',
    gray90: '#605E5C',
    gray130: '#323130',
    gray160: '#252423',
    gray190: '#11100F',

    // Backgrounds
    bgPrimary: '#FFFFFF',
    bgSecondary: '#FAF9F8',
    bgTertiary: '#F3F2F1',

    // Text
    textPrimary: '#252423',
    textSecondary: '#605E5C',
    textDisabled: '#A19F9D',

    // Borders
    borderLight: '#EDEBE9',
    borderMedium: '#C8C6C4',
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '20px',
    xxl: '24px',
    xxxl: '32px',
  },
  borderRadius: {
    sm: '2px',
    md: '4px',
    lg: '6px',
    xl: '8px',
    round: '999px',
  },
  shadows: {
    shadow2:
      '0 0.3px 0.9px rgba(0,0,0,0.1), 0 1.6px 3.6px rgba(0,0,0,0.13)',
    shadow4:
      '0 0.6px 1.8px rgba(0,0,0,0.1), 0 3.2px 7.2px rgba(0,0,0,0.13)',
    shadow8:
      '0 1.2px 3.6px rgba(0,0,0,0.1), 0 6.4px 14.4px rgba(0,0,0,0.13)',
    shadow16:
      '0 2.4px 7.2px rgba(0,0,0,0.1), 0 12.8px 28.8px rgba(0,0,0,0.13)',
  },
};

export type ThemeTokens = typeof themeTokens;
